import { render, staticRenderFns } from "./FilterChatDialog.vue?vue&type=template&id=3b161732&scoped=true"
import script from "./FilterChatDialog.vue?vue&type=script&lang=js"
export * from "./FilterChatDialog.vue?vue&type=script&lang=js"
import style0 from "./FilterChatDialog.vue?vue&type=style&index=0&id=3b161732&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b161732",
  null
  
)

export default component.exports